module.exports = __webpack_public_path__ + "static/media/active_synthesized_audio.d9afcd4f.svg";